import { ServiceHandler, applyQueryConfig } from '../utils';
import { standardQuerySerializer } from './serializers';

export interface ReMeetingActionItem {
  readonly description: string;
  readonly owner: 'Cowbell' | 'Insured' | 'Unclear';
}

/** A Zoom meeting held after a Risk Engineering request email, as summarised
 *  by chat-agent's RE meeting-notes poller. */
export interface ReMeetingSummary {
  readonly id: string;
  readonly topic: string;
  readonly meetingStart: string | null;
  readonly meetingEnd: string | null;
  readonly hostEmail: string;
  readonly participantEmail: string;
  readonly requesterName: string;
  readonly accountId: string;
  readonly accountName: string;
  readonly requestType: string;
  readonly summary: string;
  readonly keyPoints: string[];
  readonly actionItems: ReMeetingActionItem[];
  readonly nextSteps: string;
  readonly noteStatus: 'pending' | 'posted' | 'failed';
  /** How the meeting was tied to the request: Zoom withholds outside
   *  participants' emails, so those are matched by display name. */
  readonly matchedBy: 'email' | 'name';
}

export const getReMeetingSummaries = ServiceHandler<
  { msgId: string },
  { meetings: ReMeetingSummary[] }
>({
  url: '/api/chat-agent/v1/re-meetings',
  paramsSerializer: (params) =>
    standardQuerySerializer(applyQueryConfig([{ path: 'msgId' }], params)),
});

/** Which of a list page's request emails have meeting summaries, in one call. */
export const getReMeetingCounts = ServiceHandler<
  { msgIds: string[] },
  { counts: Record<string, number> }
>({
  url: '/api/chat-agent/v1/re-meetings/counts',
  method: 'POST',
});
